export default "__VITE_ASSET__BLNAw8CO__"